import { createStore } from 'vuex'

import program from './modules/program'
import user from './modules/user'
import activity from './modules/activity'
import activityV2 from './modules/activityV2'
import prakerja from './modules/prakerja'
import prakerjaDateOffsetConfig from './modules/prakerjaDateOffsetConfig'
import login from './modules/login'
import certificate from './modules/certificate'
import storage from './modules/storage'
import subnavbar from './modules/subnavbar'
// import portofolio from './modules/portofolio'
import portofolioV2 from './modules/portofolioV2'
import institution from './modules/institution'
import institutionList from './modules/institutionList'
import profession from './modules/profession'
import project from './modules/project'
import payment from './modules/payment'
import paymentHistory from './modules/paymentHistory'
import notification from './modules/notification'
import programmu from './modules/programmu'
import receipt from './modules/receipt'
import reflection from './modules/refleksi'
import tanyamu from './modules/tanyamu'
import voucher from './modules/voucher'
import funReport from './modules/funReport'
import analytics from './modules/analytics'
import discovery from './modules/discovery'
import snackbar from './modules/snackbar'
import quizV2 from './modules/quizV2'
import poin from './modules/poin'

import { isMobile } from 'mobile-device-detect'
import firebaseEventNames from '@/constants/firebaseEventNames'

const isPrakerja = location.hostname.toLowerCase().includes('prakerja')

export default createStore({
  state: {
    envBelajar: false,
    envPlatinum: false,
    platinumSubdomain: '',
    activeEnv: 'localhost',
    hostDomain: 'localhost',
    userPkey: null, // pkey for reset pin
    userVerification: null,
    codeVerification: null,
    ogMeta: ['og:title', 'og:type', 'og:image', 'og:url', 'og:description'],
    term: 'class',
    kariermuRewriteUrl: isPrakerja ? process.env.VUE_APP_URL_REWRITE_PRAKERJA : process.env.VUE_APP_URL_REWRITE,
    kariermuJobsEntry: process.env.VUE_APP_URL_REWRITE + '/jobs/',
    isShownWhatsappInputDialog: false,
    isPrakerja
  },
  getters: {
    termText: (state) => {
      return state.term === 'class' ? 'Paket Kelas' : 'Paket Belajar'
    }
  },
  mutations: {
    SET_ENV_BELAJAR (state) {
      state.envBelajar = !isPrakerja
    },
    SET_ACTIVE_ENVIRONMENT (state) {
      const hostName = location.hostname.trim().toLowerCase()
      if (hostName.includes('.dev.karier.mu')) {
        state.activeEnv = 'development'
      } else if (hostName.includes('.staging.karier.mu')) {
        state.activeEnv = 'staging'
      } else if (hostName.includes('.karier.mu')) {
        state.activeEnv = 'production'
      } else {
        state.activeEnv = 'localhost'
      }
    },
    SET_ENV_PLATINUM (state) {
      const nonPlatinumSubdomain = ['www', 'belajar', 'prakerja', 'app', 'vue3', 'localhost', 'rewrite', 'prakerjavue3']
      const currentSubDomain = location.hostname.toLowerCase().split('.')[0]

      const isPlatinum = !nonPlatinumSubdomain.includes(currentSubDomain)
      state.envPlatinum = isPlatinum
      // state.platinumSubdomain = isPlatinum ? currentSubDomain : ''
    },
    SET_PLATINUM_SUBDOMAIN (state, { subdomain }) {
      state.platinumSubdomain = subdomain
    },
    SET_HOST_DOMAIN (state) {
      if (location.hostname.toLowerCase().includes('karier')) {
        state.hostDomain = 'karier.mu'
      }
    },
    SET_VERIFICATION (state, { verification, code }) {
      state.userVerification = verification
      state.codeVerification = code
    },
    SET_PIN_PKEY (state, payload) {
      state.userPkey = payload
    },
    TOGGLE_WHATSAPP_INPUT_DIALOG (state, payload) {
      state.isShownWhatsappInputDialog = payload
    }
  },
  actions: {
    logEventTracker ({ state }, payload) {
      let eventObj = null
      const {
        module,
        key = '',
        isTrack = true,
        additionalField = {}
      } = payload
      const validKey = key.toUpperCase()
      const validModuleName = module.toUpperCase()
      switch (validModuleName) {
        case 'ACTIVITY_V2':
          const platform = 'kariermu'
          if (isTrack && state.user.isLogin && state.user.userInfo) {
            eventObj = {
              platform,
              user_id: state.user.userInfo.id,
              user_profession: state.user.userInfo.profession_name,
              user_year_level: state.user.userInfo.year_level_name,
              program_id: state.activityV2.validate.program_id,
              source: isMobile ? `mweb_${platform}` : `web_${platform}`
            }
          }
          break

        default:
          break
      }
      if (eventObj && firebaseEventNames[validModuleName][validKey]) {
        window.firebaseAnalytics.logEvent(firebaseEventNames[validModuleName][validKey], {
          ...eventObj,
          ...additionalField
        })
      }
    }
  },
  modules: {
    program,
    user,
    activity,
    activityV2,
    prakerja,
    prakerjaDateOffsetConfig,
    login,
    payment,
    certificate,
    storage,
    subnavbar,
    // portofolio,
    portofolioV2,
    institution,
    institutionList,
    profession,
    project,
    notification,
    paymentHistory,
    programmu,
    receipt,
    reflection,
    tanyamu,
    voucher,
    funReport,
    analytics,
    discovery,
    snackbar,
    quizV2,
    poin
  }
})
